// Getting the card out (sprint 28 item 2). Phone: the Web Share API with the picture. Desktop: the picture is downloaded and
// a ready post for X is copied. Any failure falls back, none throws. nav, save and doc are injected so a test can hold them.
//   how: 'shared' | 'cancelled' | 'downloaded'; copied: the post text reached the clipboard.
export async function shareOut({ file, text, nav = globalThis.navigator, phone = false, save, reduced = false }) {
  if (phone && file && typeof nav?.share === 'function' && nav.canShare?.({ files: [file] })) {
    try { await nav.share({ files: [file], text }); return { how: 'shared', copied: false, reduced }; }
    catch (e) { if (e?.name === 'AbortError') return { how: 'cancelled', copied: false, reduced }; /* the sheet failed: fall back */ }
  }
  try { await save?.(file); } catch { /* no download: the post text may still copy */ }
  let copied = false;
  try { await nav?.clipboard?.writeText(text); copied = true; } catch { /* no clipboard */ }
  return { how: 'downloaded', copied, reduced };
}

// The line on the button afterwards.
export const shareDone = r => (r.how === 'shared' ? 'Shared' : r.how === 'cancelled' ? 'Share' : r.copied ? 'Saved, copied' : 'Saved');

// Save a File through a link click (doc: the page's document).
export function saveFile(file, doc = globalThis.document, url = globalThis.URL) {
  const a = doc.createElement('a'), href = url.createObjectURL(file);
  a.href = href; a.download = file.name;
  doc.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => url.revokeObjectURL(href), 4000);
}

// A picture file, loaded; null if it will not load (the caller falls back).
export function loadImage(src, make = () => new Image()) {
  return new Promise(res => { const img = make(); img.onload = () => res(img); img.onerror = () => res(null); img.src = src; });
}

// Draw the plan at a size into a PNG File.
export function cardFile(plan, size, name, { draw, doc = globalThis.document }) {
  const canvas = doc.createElement('canvas');
  draw(canvas, plan, size);
  return new Promise((res, rej) => canvas.toBlob(b => (b ? res(new File([b], name, { type: 'image/png' })) : rej(new Error('no picture'))), 'image/png'));
}
